(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Campaign = window.Dashboard.Models.Campaign || {};

    class Campaign {

        initialiseCampaign(campaign, LocalisationService) {
            const newCampaign = Object.assign(this, campaign);
            if (LocalisationService) {
                newCampaign.LastRunFormatted = newCampaign.LastRun ? LocalisationService.formatDate(newCampaign.LastRun) : '';
            }
            return newCampaign;
        };

        initialiseCampaignList(campaign, LocalisationService) {
            const newCampaign = Object.assign(this, campaign);
            newCampaign.StartDateFormatted = LocalisationService.formatDateLong(newCampaign.StartDate);
            newCampaign.EndDateFormatted = LocalisationService.formatDateLong(newCampaign.EndDate);
            newCampaign.DeactivatedDateFormatted = LocalisationService.formatDateLong(newCampaign.DeactivatedDate);
            newCampaign.StartDateTimeFormatted = LocalisationService.formatToFullDateTimeLong(newCampaign.StartDate);
            newCampaign.EndDateTimeFormatted = LocalisationService.formatToFullDateTimeLong(newCampaign.EndDate);
            newCampaign.DeactivatedDateTimeFormatted = LocalisationService.formatToFullDateTimeLong(newCampaign.DeactivatedDate);
            return newCampaign;
        };

        /**
         * The Id of the campaign template
         * @type {number}
         */
        Id = undefined;

        /**
         * The campaign template version
         * @type {number}
         */
        Version = undefined;

        /**
         * The name of the campaign
         * @type {string}
         */
        Name = undefined;

        /**
         * The description of the campaign
         * @type {string}
         */
        Description = undefined;

        /**
         * The target customers of the campaign
         * @type {string}
         */
        TargetCustomers = undefined;

        TargetCustomersSource = undefined;

        /**
         * The terms and conditions of the campaign
         * @type {string}
         */
        Terms = undefined;

        /**
         * The terms and conditions URL of the campaign
         * @type {string}
         */
        TermsUrl = undefined;

        /**
         * The lead time for the campaign
         * @type {number}
         */
        LeadTimeWorkDays = undefined;

        /**
         * The cool off period for the campaign
         * @type {number}
         */
        CoolOffPeriod = undefined;

        /**
         * The start date for the campaign
         * @type {Date}
         */
        StartDate = undefined;

        /**
         * The end date for the campaign
         * @type {Date}
         */
        EndDate = undefined;

        /**
         * The deactivated date for the campaign
         * @type {Date}
         */
        DeactivatedDate = undefined;

        /**
         * The date at which customer data has been initialized for the campaign
         * @type {Date}
         */
        CustomerDataInitialised = undefined;

        /**
         * The launch date for the campaign
         * @type {Date}
         */
        LaunchDate = undefined;

        /**
         * @type {Date}
         */
        LastRun = undefined;

        /**
         * The minimum duration for the campaign
         * @type {number}
         */
        MinDuration = 0;

        /**
         * The maximum duration for the campaign
         * @type {number}
         */
        MaxDuration = 0;

        /**
         * The maximum number of customers for the campaign
         * @type {number}
         */
        MaxCustomers = 0;

        /**
         * The number of customers who are opted in to receive SMS messages
         * @type {number}
         */
        CustomersOptedInForSMS = undefined;

        /**
         * The number of customers who are opted in to receive Push notifications
         * @type {number}
         */
        CustomersOptedInForPush = undefined;

        /**
         * The number of customers who are opted in to receive SMS, but are opted out of Push
         * @type {number}
         */
        CustomersOptedInForSMSOnly = undefined;

        /**
         * The number of customers who are opted in to receive Push notifications, but are opted out of SMS
         * @type {number}
         */
        CustomersOptedInForPushOnly = undefined;

        /**
         * The number of customers who are opted in to receive Emails
         * @type {number}
         */
        CustomersOptedInForEmail = undefined;

        /**
         * The cost per SMS message
         * @type {number}
         */
        CostPerSMS = undefined;

        /**
         * The cost per push message
         * Currently hardcoded to 0.06. This will be overridden by the api result once implemented.
         * @type {number}
         */
        CostPerPush = 0.06;

        /**
         * The average order value per customer for this campaign
         * @type {number}
         */
        AverageOrderValuePerCustomer = undefined;

        /**
         * A collection of available start dates that can be selected for the campaign
         * @type {Array}
         */
        AvailableStartDates = [];

        /**
         * A collection of available end dates that can be selected for the campaign
         * @type {Array}
         */
        AvailableEndDates = [];

        /**
         * A dictionary collection of available communication dates that can be selected for the campaign with the start
         * date as the key
         * @type {Array}
         */
        AvailableCommunicationDates = [];

        /**
         * A dictionary collection of available communication dates that can be selected for the campaign with the start
         * date as the key. This includes sundays and public holidays
         * @type {Array}
         */
        AvailableCommunicationDatesIncludingSundaysAndPublicHolidays = [];

        /**
         * A collection of time rules for each day of the week to limit min and max times
         * @type {Array}
         */
        DayOfWeekMarketingRules = [];

        /**
         * A collection of actions for the campaign
         * @type {Object}
         */
        TemplateActions = {
            Vouchers: [],

            Menuscripts: [],

            Communications: []
        };

        /**
         * A collection of comms for the campaign
         * @type {Array}
         */
        Comms = [];

        /**
         * The publish start date for the campaign
         * @type {Date}
         */
        PublishStartDate = undefined;

        /**
         * The publish end date for the campaign
         * @type {Date}
         */
        PublishEndDate = undefined;

        /**
         * The selected number of customers for the campaign
         * @type {number}
         */
        SelectedCustomerCount = undefined;

        /**
         * The selected number of customers that will receive an SMS
         * @type {number}
         */
        SelectedSMSCount = undefined;

        /**
         * The number of messages sent
         * @type {number}
         */
        MessagesSent = undefined;

        /**
         * The number of coupons redeemed
         * @type {number}
         */
        CouponsRedeemed = undefined;

        /**
         * The formatted start date
         * @type {string}
         */
        StartDateFormatted = undefined;

        /**
         * The formatted end date
         * @type {string}
         */
        EndDateFormatted = undefined;

        /**
         * The number of customers for the campaign
         * @type {number}
         */
        Customers = undefined;

        /**
         * The date format
         * @type {string}
         */
        DateFormat = undefined;

        /**
         * The time format
         * @type {string}
         */
        TimeFormat = undefined;

        IsFavourite = false;

        TargetSourceUrl = undefined;

        /**
         * Returns whether this campaign is an SMS campaign
         */
        HasSMS() {
            return _.contains(
                this.CommunicationTypes,
                Dashboard.Models.Lookups.CommunicationMessageTypes.SMS
            );
        };

        /**
         * Returns whether this campaign is an Pushnotification campaign
         */
        HasPush() {
            return _.contains(
                this.CommunicationTypes,
                Dashboard.Models.Lookups.CommunicationMessageTypes.PushNotification
            );
        };

        /**
         * Returns whether this campaign is an voucher campaign
         */
        HasVoucher() {
            return _.contains(this.Actions, Dashboard.Models.Lookups.CampaignActions.Voucher);
        };

        /**
         * Returns whether this campaign is an menuscript campaign
         */
        HasMenuscript() {
            return _.contains(this.Actions, Dashboard.Models.Lookups.CampaignActions.MenuScript);
        };

        DaysCampaignConsideredNew = 30;
        ExpiryThresholdInDays = 15;

        /**
         * Returns whether this campaign is new
         */
        setIsNewFlag() {
            var fromDate = new moment(this.PublishFrom);
            var difference = new moment().diff(fromDate, 'days');
            this.IsNew = difference < this.DaysCampaignConsideredNew;
        };

        setSortableByNewestOrFavourite() {
            this.IsNewOrFavourite = this.IsFavourite
                ? -1
                : this.IsNew
                    ? 1
                    : 0;
        };

        /**
         * Returns whether this campaign is expiring soon
         */
        ExpiringSoon() {
            var toDate = new moment(this.PublishTo);
            var difference = toDate.diff(new moment(), 'days');
            return difference < this.ExpiryThresholdInDays;
        };

        /**
         * Returns true unless the campaign has been deactivated already
         * @return {boolean}
         */
        IsCancellable() {
            return !this.DeactivatedDate;
        };

        /**
         * Returns true if the campaign is currently enrolling customers
         * We assume enrollment has begun if customerDataInitialised is true and the campaign has not yet launched
         * @return {boolean}
         */
        IsEnrolling() {
            if (this.LaunchDate) {
                const customerDataInitialised = !!this.CustomerDataInitialised;
                const launchDate = new moment(this.LaunchDate);
                const dateAsOfNow = new moment();
                const hasCampaignLaunched = launchDate.isSameOrBefore(dateAsOfNow);
                return customerDataInitialised && !hasCampaignLaunched;
            } else {
                return false;
            }
        };

        /**
         * Returns how many days are left before this campaign expires
         */
        ExpiresInDays() {
            var toDate = new moment(this.PublishTo);
            var difference = toDate.diff(new moment(), 'days');
            return difference;
        };

        /**
         * Checks to see if the name or description contains the given string
         * @param searchText {string}
         */
        NameOrDescriptionContains(searchText) {
            const matchesText = searchText == "" ? true :
                this.Name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1 ||
                this.Description.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
            return matchesText;
        };

        /**
         * Shows the expires in days section if within the required days
         * @param localisationService {service}
         * @param interpolate {object}
         */
        ExpiresMessage(localisationService, interpolate) {
            var daysRemaining = this.ExpiresInDays();
            if (daysRemaining < this.ExpiryThresholdInDays) {
                var interpolateExpiresInDays = interpolate('Expires in {{daysRemaining}} days');
                return interpolateExpiresInDays({
                    daysRemaining: daysRemaining
                });
            }
            var expiresDate = localisationService.formatDateLong(this.PublishTo);
            var interpolateExpiresOnDate = interpolate('Expires on {{expiresDate}}');
            return interpolateExpiresOnDate({
                expiresDate: expiresDate
            });
        }
    }

    window.Campaign = Campaign;
    window.Dashboard.Models.Campaign = Campaign;
})();
